export const contactActionTypes = {
    START_SUBMIT_CONTACT:'START_SUBMIT_CONTACT',
    SUBMIT_CONTACT_SUCCESS:'SUBMIT_CONTACT_SUCCESS',
    SUBMIT_CONTACT_FAILURE:'SUBMIT_CONTACT_FAILURE',
}